export type SmartBannerLabels = {
  /**
   * The name of the app to display
   */
  appName: string;

  /**
   * A brief description of what the app offers
   */
  appDescription: string;

  /**
   * Text for the primary call-to-action button
   */
  ctaText: string;

  /**
   * Custom aria-label for the banner
   */
  ariaLabel: string;

  /**
   * Aria-label for the dismiss button
   */
  dismissLabel: string;
};
export const DEFAULT_LABELS = {
  appDescription: "Book & manage trips",
  appName: "JetBlue",
  ariaLabel: "App download banner",
  ctaText: "Open",
  dismissLabel: "Dismiss banner",
} satisfies SmartBannerLabels;
